module.exports = __webpack_public_path__ + "img/mgh-fukuoka-nakasu-sp.01653365.jpg";